import { exists } from '../exists/exists';

export const kebabCase = (str: string) => {
  if (!exists(str)) return '';
  return str.split(' ').join('-').toLowerCase();
};
